import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import commonStore from './js/store/commonStore.js';
import {Provider} from 'react-redux';
import 'bootstrap/dist/css/bootstrap.css';
import _ from "lodash";
import 'animate.css';
import {RenditionLoadable} from './js/utils/general/LoadableRelated';
import {isParentDomainRegistered, isAppInsideIFrame} from './js/utils/general/general';
import cvDomainOperation from './js/utils/general/cvDomainOperation';
import Loadable from 'react-loadable';
import $ from 'jquery';
import { renditionAjaxStart, renditionAjaxStop} from './js/services/ajax-services';
import { getEPFTokensBasedOnParams } from './js/utils/general/EpfTokensUtils';

// Execute the ajax start here to wait for first ajax call start.
renditionAjaxStart();
// Execute the ajax stop to wait for all ajax calls complete.
renditionAjaxStop();

window.HTML_RENDITION.isMCN = window.HTML_RENDITION.initialData.productType == 'multicompany' || window.HTML_RENDITION.initialData.productFocus == 'MULTICOMPANY';
window.HTML_RENDITION.isRoundup = window.HTML_RENDITION.initialData.productType === 'roundup' || (window.HTML_RENDITION.initialData.productFocus == 'UNFOCUSED' && window.HTML_RENDITION.initialData.templateCode == 'Roundup');
window.HTML_RENDITION.isGlobalizer = window.HTML_RENDITION.initialData.productFocus == 'UNFOCUSED' && window.HTML_RENDITION.initialData.templateCode == 'Globalizer';
window.HTML_RENDITION.isPoint = window.HTML_RENDITION.initialData.productType === 'point' || (window.HTML_RENDITION.initialData.productFocus == 'UNFOCUSED' && window.HTML_RENDITION.initialData.templateCode == 'Point');
window.HTML_RENDITION.isOffCuffList =
    window.HTML_RENDITION.initialData.productType === 'blog' &&
    window.HTML_RENDITION.initialData.mode !== 'preview_mode' &&
    !window.HTML_RENDITION.initialData.isStaticHtmlExport &&
    !window.HTML_RENDITION.initialData.isStaticHtml &&
    (window.HTML_RENDITION.initialData.urlParameters.pureContent === 'false' || !window.HTML_RENDITION.initialData.urlParameters.pureContent) &&
    !window.HTML_RENDITION.initialData.pureContent;
window.HTML_RENDITION.isOffCuffContent =
    window.HTML_RENDITION.initialData.productType === 'blog' &&
    (window.HTML_RENDITION.initialData.urlParameters.pureContent === 'true' || window.HTML_RENDITION.initialData.pureContent);
window.HTML_RENDITION.isBlogPrintMode =
    window.HTML_RENDITION.initialData.productType === 'blog' &&
    window.HTML_RENDITION.initialData.urlParameters.print === 'true';
window.HTML_RENDITION.initialData.finalCopyUrl = new Map();

// Execute the CV domain cross issue.
cvDomainOperation();

// Commented below code for easy see log in develop
// overwriteConsole.renditionConsole();
const store = commonStore;

const productType = window.HTML_RENDITION.initialData.productType;
const themeFromURL = "";
//  _.get(
//     _.get(_.get(window, "location.href", "").split("?"), "[1]", "").split("="),
//       "[1]",
//       ""
// );
const showOldBranding = themeFromURL === "" ? (_.includes(["globalinsights","gps"],productType) ||
    window.HTML_RENDITION.initialData.enable2023rebranding === 'false') : themeFromURL === "old" ? true : false;

const OverviewContainer = RenditionLoadable({
    loader: () => import('./js/containers/overviewContainer'),
}, "OverviewContainer", Date.now());

//document.cookie = 'cp-wl = UCV4A8E008DB79140D2A7D5692F62B01DC319SMAMUKAB195924402@2';

let showErrorMsg = null;

const checkForErrors = () => {
let isError = false;
    const errorMsg = window.HTML_RENDITION.initialData.RENDITION_ERROR;
    if (errorMsg != 'null' && errorMsg != null) {
        isError = true;
        showErrorMsg = {
            message: errorMsg,
            type: 'showErrorPopup'
        };
    } else if (isAppInsideIFrame() && !isParentDomainRegistered()) {
        console.log('isAppInsideIFrame, and not isParentDomainRegistered, and then Frame is blocked, show error popup');
        isError = true;
        showErrorMsg = {
            message: 'Frame is blocked',
            type: 'showError'
        };
    }

    return isError;
};

let expg = null;
const isRequestCompanyModel = () => {
    if (window.HTML_RENDITION.initialData.ORG_URI?.indexOf('request_company_model') > -1) {
        expg = 'rcm';
        return true;
    }
    return false;
};
const isCorporateAccessInterest = () => {
    if (window.HTML_RENDITION.initialData.ORG_URI?.indexOf('corporate_access_interest') > -1) {
        expg = 'cai';
        return true;
    }
    return false;
};

let actualContainer = null;

if (checkForErrors()) {
    const ErrorPageContainer = RenditionLoadable({
        loader: () => import('./js/containers/errorPageContainer'),
    }, "ErrorPageContainer", Date.now());
    actualContainer = <ErrorPageContainer errorMsg={showErrorMsg}/>;
} else if (window.location.search.indexOf("popup=true") >= 0) {
    const PopupContainer = RenditionLoadable({
        loader: () => import('./js/containers/popupContainer'),
    }, "PopupContainer", Date.now());
    actualContainer = <PopupContainer showOldBranding={showOldBranding}/>;    
} else if (window.HTML_RENDITION.initialData.isReactEmailPreview === true) {
    const EmailPreviewContainer = RenditionLoadable({
        loader: () => import('./js/containers/emailPreviewContainer'),
    }, "EmailPreviewContainer", Date.now());
    actualContainer = <EmailPreviewContainer/>;
} else if (window.HTML_RENDITION.initialData.isReactPreviewLoadingPage === true) {
    const PreviewLoadingContainer = RenditionLoadable({
        loader: () => import('./js/containers/previewLoadingContainer'),
    }, "PreviewLoadingContainer", Date.now());
    actualContainer = <PreviewLoadingContainer/>; 
} else if (isRequestCompanyModel() || isCorporateAccessInterest()) {
    const ExternalContainer = RenditionLoadable({
        loader: () => import('./js/containers/externalPageContainer'),
    }, "ExternalContainer", Date.now());
    actualContainer = <ExternalContainer expg={expg} showOldBranding={showOldBranding}/>; 
} else if (window.HTML_RENDITION.initialData.isStandaloneMacroForecast) {
    const MacroForecastContainer = RenditionLoadable({
        loader: () => import('./js/containers/macroForecastContainer'),
    }, "MacroForecastContainer", Date.now());
    actualContainer = <MacroForecastContainer />; 
}
else {
    const tokens = getEPFTokensBasedOnParams();
    console.log('OverviewContainer get tokens for epftoken on params=', window.location.href, tokens)
    actualContainer = <OverviewContainer showOldBranding={showOldBranding}/>;
}

const loadModelityBranding = () => {
    let Branding: any;

    if (showOldBranding) {
      Branding = RenditionLoadable({
        loader: () => import('./dynamicComponents/modelityOld'),
      }, "modelityOld", Date.now());
    }
    else {
      Branding = RenditionLoadable({
        loader: () => import('./dynamicComponents/modelityNew'),
      }, "modelityNew", Date.now());
    }

    return <Branding/>;
  }

  const loadDefaultBranding = () => {
    let Branding: any;

    if (showOldBranding) {
      Branding = RenditionLoadable({
        loader: () => import('./dynamicComponents/defaultOld'),
      }, "defaultOld", Date.now());
    }
    else {
      Branding = RenditionLoadable({
        loader: () => import('./dynamicComponents/defaultNew'),
      }, "defaultNew", Date.now());
    }

    return <Branding/>;
  }

  const loadWordStyleOverrideBranding = () => {
    let Branding: any;

    if (showOldBranding) {
      Branding = RenditionLoadable({
        loader: () => import('./dynamicComponents/wordStyleOverrideOld'),
      }, "wordStyleOverrideOld", Date.now());
    }
    else {
      Branding = RenditionLoadable({
        loader: () => import('./dynamicComponents/wordStyleOverrideNew'),
      }, "wordStyleOverrideNew", Date.now());
    }

    return <Branding/>;
  }

  const loadFontsBranding = () => {
    let Branding: any;

    if (showOldBranding) {
      Branding = RenditionLoadable({
        loader: () => import('./dynamicComponents/fontsOld'),
      }, "fontsOld", Date.now());
    }
    else {
      Branding = RenditionLoadable({
        loader: () => import('./dynamicComponents/fontsNew'),
      }, "fontsNew", Date.now());
    }

    return <Branding/>;
  }

const isStaticHtml = window.HTML_RENDITION.initialData.isStaticHtml;
console.log((isStaticHtml ? 'Hydrate' : 'Render') + ' react page');
if (!isStaticHtml){
    ReactDOM.render(<Provider store={store}><div>{loadFontsBranding()}
    {loadDefaultBranding()}
    {loadModelityBranding()}
    {loadWordStyleOverrideBranding()}
    {actualContainer}    
    </div></Provider>,
        document.getElementById('root'));
} else {
    const c = actualContainer;
    Loadable.preloadAll().then(() => { // preload all loadable components, then hydrate
        ReactDOM.hydrate(<Provider store={store}><div>{loadFontsBranding()}
        {loadDefaultBranding()}
        {loadModelityBranding()}
        {loadWordStyleOverrideBranding()}
        {c}       
        </div></Provider>,
            document.getElementById('root'),
        function (){
            setTimeout(function (){
                const staticHtmlexternalJS = window.HTML_RENDITION.initialData.staticHtmlexternalJS;
                console.info('Static html externalJS', staticHtmlexternalJS);
                if (staticHtmlexternalJS && staticHtmlexternalJS != 'STATIC_HTML_EXTERNAL_JS'){
                    console.log('Page was hydrating completely, start to import external JavaScript');
                    const alphasenseScript = document.createElement('script');
                    alphasenseScript.type = 'text/javascript';

                    const src = staticHtmlexternalJS;
                    alphasenseScript.src = src;
                    console.info('External JavaScript src', src);
                    alphasenseScript.charset = "utf-8";

                    $('body').append(alphasenseScript);
                    console.log('Importing external JavaScript is done');
                }
            }, 2000);
        });
    });
}